import { render, staticRenderFns } from "./SearchFormOthOrderNo.vue?vue&type=template&id=72a51428&scoped=true"
import script from "./SearchFormOthOrderNo.vue?vue&type=script&lang=js"
export * from "./SearchFormOthOrderNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a51428",
  null
  
)

export default component.exports